import React from "react"
import DfbRte from "../ui-kit/dfb_rte"
import DfbHeadline from "../ui-kit/dfb_headline"
import DfbButton from "../ui-kit/dfb_button"
import Section from "./section"

const MSandwich = (props) => {
  return (
    <Section
      baseClass="m-Sandwich"
      defaultBgColor={"white"}
      defaultPadding="large"
      data={props.data}
    >
      <div className="m-Sandwich-wrapper">
        <div className="m-Sandwich-container">
          <div className="c-Headline m-Sandwich-headline">
            <DfbHeadline
              headline={props.data.headline}
              headline_level="h2"
              add_class="c-Headline-strokeLine"
            />
          </div>
          <div className="m-Sandwich-info">
            <ol className="c-Accordion c-Accordion--sandwich">
              {props.data.sandwich_item.map((item, index) => (
                <li
                  className="c-Accordion-item c-Accordion-item--sandwich"
                  data-item={index + 1}
                >
                  <button className="c-Accordion-button c-Accordion-button--sandwich">
                    <span className="c-Accordion-icon c-Accordion-icon--sandwich">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="currentColor"
                          d="M12 1C5.9 1 1 5.9 1 12s4.9 11 11 11 11-4.9 11-11S18.1 1 12 1zm0 20c-5 0-9-4-9-9s4-9 9-9 9 4 9 9-4 9-9 9z"
                        />
                        <path
                          className="horizontally"
                          fill="currentColor"
                          d="M6 11h12v2H6z"
                        />
                        <path
                          className="vertically"
                          fill="currentColor"
                          d="M13 6v12h-2V6z"
                        />
                      </svg>
                    </span>
                    <span className="c-Accordion-buttonTitle">
                      {item.headline}
                    </span>
                  </button>
                  <div className="c-Accordion-content">
                    <div className="c-Accordion-sandwich">
                      {item.text && <DfbRte text={item.text} />}
                      {item.link && (
                        <DfbButton
                          tagName="a"
                          link={item.link}
                          text="Mehr erfahren"
                        />
                      )}
                    </div>
                  </div>
                </li>
              ))}
            </ol>
          </div>
          <div className="m-Sandwich-graphic">
            <svg
              id="Sandwich_Graphic"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              viewBox="0 0 639.7 426"
            >
              <style
                dangerouslySetInnerHTML={{
                  __html: ".st2,.st3,.st8{;enable-background:new}",
                }}
              />
              <g id="Schatten">
                <image
                  width={516}
                  height={183}
                  xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgQAAAC3CAYAAABtw0ZkAAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAFrdJREFUeNrs3euS4jCyhVHJ9Lz/ Czf2+XN6hnBYmTtTki/w7QgCMFBFUaBcpHx5FUIIIYT8fF68BIQQQggBBIQQQggBBIQQQggBBIQQ QggBBIQQQggBBIQQQggBBIQQQggBBIQQQggBBIQQQggBBIQQQgj5byovASHkC8abjZeXEEBACGFs AQmEAAJCyBeMI8rPGFHgQQIhgIAQcuG4ccZYs530GEL4YBNCGCc67z9jzNkGFnyAQPigE0JIYlyo F6Mgg4Ft0M8nBBAQQgBAEgU1+DuUgrx1YgAgEAIICOFzPwgANXi9d/xRCvuWeAxAIAwMhBA+50kA VPG22vG8IsV/S9wPIBAGCl4CQgBABwAil6vwHGugyB4VdwUGKh4AAmHgIIQAgM5CXwP3yYBgE1Cg 3AcgEAIICAEAnQAYda78XZsDglHnAIEwsBBCAEAHALxlPSiIYKB12VoGEAgBBIQAgAEAqMnbrOdi FUoFApnbAAJh4CGEAIBOAFThtmi3INsVsJYBBEIAASEAYCIAlFMRcKAUQ6UDED0BBMLAxEtACAAQ v9WrpyUAgx4QKBBYB+AAIBAGKkIIAEgU/kW4TxQFEQysAggiUAAIhIGLEAIAjOK+BC8rXYMICJSu gHIZIBACCAgBAJ0A8M69n1MEFFjrC6wCBrxzgEAIICAEAAwAgLpsNgiOCr66DCAABAY6XgJCAIAI gNay1n2OLremEUoDBa3NDFsgWMXLESgABMLARwifAwDQuHx0Xblf67lkQOBh4Oi6cj+AABAYCAnh fQ8AEgCwTkc/Q+kSlAYKPBBYCLBOAAEgMDDyEhDe5wDAKPgqAl4iCrwtD6zCY21RoGDgncQBQAAI DJSEAAAAIBb+V6BTMLpDoHYG3kkoAASAwMBJCAAAAB3LLBi0tjbYv8atdQhaKwVGQaAuAwgAgYGU EAAAAILXW8tq8acNLBBYHYItWezfBSAABAIICAAAAGEAKJf3j60GDEZOGfy7rkwNKJcBAkBgoCUE AAAA4/Ir2C2wMLA0XtMWBkpp74xInSo4AgBAAAgMvLwEBAAAgCQAIjDwVircv877omDth6BVeBUI AASAQAABAQAAIACALATUdQhKye+YKLq5YQYDAAEgMDATAgAAQMmvQ+BNF7S6A/WgmHwWn+i0QWYd AoAAEBioCQEAAKDMWW9gdofgjPUJAAJAAASEAAAAID4nb8sCbx8E1SkuSpfAW6cAIAAEAggIAAAA HQCITA8o+x/IgkA97HG2YwAQAAIDOyEAAACU+F4IF+d1UqcKvCmDUvSjHkYPdAQQAAIDPSEAAAAk AaB0BJQ9E2ZBoK5TkDkKIkAACAz8BAAAAAAwCAFZDIxGQS8OAAJA2CgEBAAAAABgryjorTi4HPzv RoKgGAVL2RoBIACEnwcCIAAAAAAAZAGwOK91LdouiqvwPvVQUBpFyEICQAAII4Gw/VKhIAAAAACA KnYEqvO/nQECq8hYHQOAABAAAiAAAAAAAAwEwCL+n6MY6EFBEQoSQAAIs4GwfVshIQAAAACAKnQE ini5FwTFKQjKyocAASCMBMKjcQAIAAAAAAC9ADj6P6sdgSq8V7dAp8DCQBGnFAACQNgciGau3x4G gAAAAAAAMAIAWQT0gKAHBwABIGSAsAXfl0rx355YeAgAAAAAQAVATbwPlURauxtAAAgiEtT3izd9 1YOD7UmFiAAAAAAAVAAo6wmo7+3I3K3XPQAIACELhNHTDLeDASAAAAAAAEQAkJ0OUDoCymaHvR0D dVoBIAAEZZph1sqKl8AAEAAAAAAARgOgJt7f0Q6B2j1QOwcA4XeAEMVBz3RDFgmXwAAQAAAAAABm AqBOHHvUARQg/BYQlONZeN0DFQ0jphqsKYZTUQAIAAAAAACzAVAHfp4ym3IBhO8GQk8XQZ1yUKBQ hOWZzsFpKAAEAAAAAIAzATBjzOmZUgAIzwLCO/C3qEhQsDB6vYQWErxuwXaXQgcAAAAAAAB3AABA +E0gZLsHChay6yRkpxuOphq8rsF0FAACAAAAAMAoANSTxqBt4GMAwnOAkO0eZNZJiCBhxMqL6lQC IAAAAAAAfAUAZo4326D7A4RrgDCzkzCis9C7ImNkHYTLUPArIAAAAAAAfBcAAMJvAOE9uNswcxpC RYIFA+t9MX3q4FtBAAAAAAD4LQAAhOcBQYFAFAc99+3tOihIUGBQnK4BIBj4twAAAAAAvh8AAOF+ QOjFgVfII497J3/Xu8TWa1gT0wpet2AaCp78gQYAAAAAAACAcA0QepHwTl5Wi7u3zLqP9Rjv8ZHu wdFKiWq3ABCIzxcAAAAAAAAAwjwgeNvwq0iY0TFQC7i3TLktggS1a6DCYAoKnvCBzyAAAAAAAAAA AEIOCN629REYWJv0eSv09XYIMgBonf4G73/0PI7+Lm/TxVO7BHcdADK7Oq0AAAAAAAAAELqBsO6W KXvri3YPtoPC2CqcHgyiIIgU/b/G7VkkZDsFrS7B14Igsscz9ToAAAAAAAAABHtlNQsJqzjV0Du1 0DOF4E0VqAg4AsDf4G1HP2sVYXBpl+AuA4QKgWgXoBcAkeIPAAAAACBPBoLSRZgFg8359tyzHkEv AI7OW5fV7kELBZH1CYaD4M9NITCr/Q8AAAAAIFeMbVvy/kfLvS9Qn/fZdsv2t/XAoASmEiwY/Lv+ OgEEy0fB/jem/G2MN/sxxPuMff79y8Hr8TkubY1x6fP/dHr+3OTDEukGeAiY1f4HAAAAAJC7A2E7 eD9uIhQiSNhfX3bFfinxlRGtlRCX3fnr/wv7/nzZ3XdxxpgqjBneZ+4IS6/d370HgvV7LRS0bh+C iD8XfyhKYHA985s/AAAAAIDcFQibsVztKFSje3CEBLVrUI3rS6O414/L6+7y+nGf9eMb/uflf+ef 48JbKPLKZ76FoNUZ6/Z/nweP04r+XUAQ6Qq0lrUw4BX9IhT76hSgxYEAAAAAAICcAQQVB+WgI2BB wUKBd3lzgLB+XF9353X3rXkTPt9v4/P5dtr61nJl3Ql1/FMxUI2iXwNofAwIvAEyMg0w4pt/tvD3 fvsHAAAAAJDIe6G3c7AJ15X1DYoDAwsH+5Z5KfZ++nsPb701ru9b+cuuwB8tWw7GrtpYFu0E7F/X y9YdOBME6k6CIhCY2fYf2f4HAAAAAJAzYNBqKSsw2ILTCJGug/WZio751sp4+9s+r7e+rR9NWUQL fC8GbjUG/DnpzRzpCozY3t8rQNHCrxb/TAEGAACAEDLuMxTZU+3dnvvXgkDBQD1omWS+/fcW/Uix zyAAAAAAQrLZOu+n7LdA+T2t9n6rPZ/Zn0E5uN7z+Ohjor9LfX6t13e70xvtipUKvXZRpO0fWcGv t+if2foHAACAgIDe+27i9Vl7OYzu6lg9DkL2tA24PXO6XeE/GwTqsQi8+aLWZbXNf2ax9wp59jYA AAAICMgiQO0I9BwHwfqGrO6gSDlSYnTnRL2nKDZ6sOB1Hk791j7750ZWHlHa/xYEXhNa+lYRz97/ lXweAAAAkN8DwIhOwOxuQAYEkcMmjwCBd1wC63Lr9BZui6LjkuMZzBjgWgNypCvgQcAr+NE2/FXn rWWjEAAAAAD5fgCoCPA29Zt5XIPowY5G7L7YO5bB/rJ37IJW8bfuk+lCWMczsP5/t+wQWN0Bb30B bzqgVSSV89Yy7zHRnzmqKxBFgNVBAQAAgPwuAGZOCUTWE4isK/CeBALloEZW1+BtdAD+Fu0AR6sB gksPbjR6AFS6A8oWA0onwCrcreutZa0i792WhcEICFgrTQIAAEAAwOzpAK8bkF1X4AgEGQysZcxh jyNHQlSmCFpHO9yunC44AwRed8BbWbDVWrcKe89pCdzmdR6yUwP7Zd5+EWqxD9wBAAAA+W0ARKYB ivAttWdKIDo90LrcOrphBAUKDrxpBu9ntToCre5AZrrgUSBQpgmq0xGIAuCPuMxaHuk0eJ2CKAgi nYBRCAAAhPwuANRpgFFTAiMg4B32eBVa9kpBj9we6QhYWyqsTgdnOAZGD5gjugOtzkAEAH/EZcp1 BQjqtIG6eaM6HaAcj8ECWHFAAAAIAPgdAGQRsA6aElAQoHYGLBRkkKAU/ExHwJsmOHW64GwQRLoD XkfAKvZ/Gsus8ygORoLA6wooB1xSju0d/fYPAAgAAADRb/+ZKYHezsAoIHh4WJ1v/2/nb/FWIFyF aYJpGJgJgugmhhkMtADwx7ltf1kFQgYFERB4W1lkpgJKAAMeBAAAAQC/DYBs8VcKfw8EFBhE8ZA5 V6YFIlsTnLbuwOgBNjtdoK4z0CrerdPLuZ7pGERgEJkeiHQCoh2B3mkABQAqCgAAAQC/DYCR3YCZ j1EvZwAQwcBpUwVng8Da54DXIdgXaQsE/0mAwYNBCwfqvgqi+xEYvXJgZDrg6i4AACAA4NkAyEwH ZIt89LZsgc/sxji6noDSFfg5EPR2Bv7j3O51ECwUfC4bjYGR6whEAGDBIIMCAEAAAACITAX0fItX 2/Yjinym8K/C/6ncBQOlnHu0Q/UbpjIHbu3hMLJzI2WPh/vCr+6PILqDoR4QjJoaUAp/LwRAAAEA ACDSIch+288Uf2UrCaXwr87/TpkaOP1IiTNAUMWBvwqPiRwiOXqKfjuPbg2wBJ6H9/tnbTGgdgeA AAEAAKAXAL1AmPFt33qNtsB5ZDog0xGY3h24skNQDorV6OmK1u/yuhOlUUy9598qtl4hj7buVVxF HwcGCAAAAHcDQM+KfMo3fhUAo4p/a2dDKgqmdgv+3OADvw0eNDbnd1kvsrLdZ+v5W0cQa53qx/3q wXnZ3W49j+pc9h5nLVfvF/09hAAAADBqzr+3+Pe0/ZX/u1ozphf+M0HQKmpeEbM+tJmDbigH5fh3 Wozzf/dtfctfDy6vH9+Mledh/f7oYFk/7ludx+0RUg7+J63rxVlekvcjAAAAAABlN7+Ztfsjrf7o FgFb0Q8j3Xr/Rd/nX9Eh2IzCkjny1tr4IFkfiHpw/eh8X0CrMGBFugTLrlB6Owvyph8iHQILE0WE QhYG4AAAAAAAMAoAvd/+R7T9ezsBl0HgahAoBXU7+Ja+BAu+uhKeMiXwuey1ezO8nHPlVI3z/eXI fgiOfoYCNavTcNR5qI03bw0M+AABAAAAADADABkE9H7zVzcdvGQFwitBsDW+iSr/iCMIVAcCpdgr EWamJfa/67Vb/mqcj9pT4bpDwFbm7KnQm/Kpxv/zqLBHOgIAAQAAAABwFwCMKv6b+D6+DAKjQWB9 82xND1Tng1YPru/n6d/Bol+MD3X0kJ3v8r/9Dxxdfh8gYC3POJbBUaeiNKAwq3sAEAAAAAAAVwNg VPt/Ez8325UfaI52yNEOOdohAQAA4NsBoLb/Z377vy0ErgBBMb7RWnsSVA4wpB650Cv6PQc0yoLg 5YAg0zFYBISVMnZvhwABAAAAAPCNAGgt60XAbSAwawA9Gvy9ToF15MNW4Y0AwSv2CgKWThRYxzjw ugYeDmYdFKn3uAgAAQAAAADwdAAo7f7McQa2Ow4AZ4Ag2iWoRqcgCwT1tARusxDQC4KXAQJvV8kj cAAQAAAAAAAAQN9b4GMRcCYI1C6B0imwDkT0Eq9bRX8JFv/IdIE3fRDtGqjTClYXASD8HhAAAAAA AOcB4BEImD0gRrsE1ekS1JI7SqH3rV05fPEr8TPPhoHVSagA4aeBAAAAAAAAALcCgVUYIkf+ixzS 2GvVv25yHplKiODA6yIAhO8EAgAAAADgXAA8HgFnDHjqYYyLgQIFBt4WCmqBjVyOftsf0S0YgQOA 8H1AAAAAAAAAgMeBoBRthzgeDJRphcxJ2RxwFCAyHYMZ3QOA8DwgAAAAAAAAwONAoHYJPBR4hcfq IHjXr0DD6GUA4V5AGPmZ2gY+BgAAAAAAAG4FAmUwj56WwDRDnYiF3o5CBAAA4VlAUB6XHYAAAAAA AADgESBQUdDqEkSQsEzEQgYNkQINEJ4LhDOnDaK7PQUAAAAAAIBbgUAZYL0phGz3QClC3tSDB4XI fhMAAkAAAAAAAACAnwaB0oL1gKAUhB4oqEgACAChJj9HtWOwAgAAAAAAgK8BgYICdTohM8VQxGmG LBR6kAAQvg8IPZ8tdb0AAAAAAAAAeCwI1FZrHTC1EMHCyOmGEV0EgPBsIIz4XHkDJAAAAACAPB4E mW5Bz/TC6CkHgAAQqvB+HQkC7zIAAAAAgDwaBNF2a2QQPrOTABC+HwgeFFrLMp+v1rSABwEFAwAA AAAAcmsQRKYSMlCInAMEgNADhMh7VUGABQEAAAAAAPlaEERhELmehcKIaQaA8J1AiHQNlM9ZZFqg tQwAAAAAQL4KBOrzUlbkGjXNABAAgtpJyqAgigGlKwAAAAAAIF8DguhzjG4rDhAAQhYIJTCtYL3H sl0Bq0AAAAAAAMhXg6AXBwABIIwCQg12EHpB4HUANgAAAAAA+VUQZJ47QAAIZwDB6xR4UwaRFQUB AAAAAAQQAASAcDEQlM7BSBCoEAAAAAAAEEDQ+XcBBICgAiHTMYhMGfR0BAAAAAAABBAABIBwAhA8 HHxeb00fKCD4vNwqSC0EAAAAAAAIIAAIAGEyEDwc7C/v/49H75v9QL8vIl5HIIsAAAAACAEEAAEg dAJBgYEydaBOFYyAAAAAAIQAAoAAECYA4WhdAxUFxUCBt86AigEAAAAIAQQAASBMAMJ+mbXyYWvq INIhaE0VHBVDpdgCAABACCAACABhEhBaf6+yLsF+MPdA4HUFAAAAIAQQAASAMAkIHhK8zROVaYPM ugOrUPwBAAAgBBAABIAwEQit3291CaIdArU7oHQFAAAAIAQQAASA0AmESIfAWpcgAgJv3YHeDgEA AACEAAKAABAGAKG1rBooyEwZeJsYegUbAAAAQgABQAAIE4AQ3RzxrA5BdNoAAAAAQgABQAAISSBY EHgVfxPE1mto7ZSotanhu/TvdwAAAABCAAFAAAhJIER3VjRqK4NMlwAAAABCAAH/N4AwCQjKugMW BjIg8Aq0V+QBAAAgBBDwfwQIA4Ggbm6oHvnwqLh4RziMbH4IAAAAIYCAAIROIKg4iGxd0Nsh6Dmy 4QYAAAAhgIAAhHlAiB7xcAQIFBgAAABACCAgAGEwEKqAgMX5PSUIguIUZq/Qe4AAAACAEEBAAEIC CF4nQOkMVOH19YrvKpx79wEAhBBAQADCQCB4y1rPRQFBMTDgFXkAAAAIAQQEIJwIBPX60fOyiler EK+B6wCAEAIICEA4AQjecmtFQgUERSzea3A5ACCEAAICEAYCIXJSMNCDgugJABBCAAEBCCIQVByU Mg4DGRSoaCgAgBACCAhAmAeEIl5X//6tAYNNvA4ACCGAgACEi4DgXY7+rRYKlMsAgBACCAhAOBkI 1rLRIChCsQcAhBBAQADCRUCIQsDbyiAKAwBACAEEhPfpRUCIIGAkCNRiDwAIIYCA8L49EQgRCCjP 1yvIoy4DAEIIICC8jzuA0NsJ6AVBpOADAEIIICDkIiB4vzcDggwUAAAhBBAQcjIQegCQLcg9cAAA hBAzL14CAhBS962TCuyWvB0AEEIAASEnAkG5/6wOQbagAwBCCCAg5AQgjILAqEIOAAghgICQGwHh rAAAQgggIOTHkEDxJ4QAAkJ+CAoUfkIIICCEEEIIICCEEEIIICCEEEIIICCEEEIIICCEEEIIICCE EEIIICCEEEIIICCEEEIIICCEEEIIICCEEEIIICCEEELIVfk/AQYAOZ6qJ7k5yPAAAAAASUVORK5C YII="
                  transform="translate(61.836 204.5)"
                  overflow="visible"
                  id="Schatten_2_"
                  opacity=".1"
                />
              </g>
              <g
                id="Deutsche_Tugenden_2_0"
                className="m-Sandwich-layer m-Sandwich-dtLayer"
                data-index={4}
              >
                <path
                  fill="#739b95"
                  d="M357.5 167.9L99.3 232.4v18.5L283.7 297 542 232.4V214z"
                />
                <path
                  className="st2"
                  style={{ enableBackground: "new" }}
                  opacity=".1"
                  d="M283.7 278.6V297L542 232.4V214z"
                />
                <path
                  className="st3"
                  style={{ enableBackground: "new" }}
                  opacity=".2"
                  fill="#fff"
                  d="M99.3 232.4v18.5L283.7 297v-18.4z"
                />
                <path
                  id="Deutsche_Tugenden_2_0_White"
                  opacity=".4"
                  fill="#fff"
                  d="M99.3 250.9v-18.5l258.2-64.5L542 214v18.4L283.7 297z"
                />
              </g>
              <g
                id="Trainingsvision"
                className="m-Sandwich-layer m-Sandwich-tvLayer"
                data-index={3}
              >
                <path
                  fill="#85d3b9"
                  d="M357.6 130.4L99.4 195v18.4l184.4 46.2L542 195v-18.4z"
                />
                <path
                  className="st2"
                  opacity=".1"
                  d="M283.8 241.1v18.5L542 195v-18.4z"
                />
                <path
                  className="st3"
                  opacity=".2"
                  d="M99.4 195v18.4l184.4 46.2v-18.5z"
                />
                <path
                  id="Trainingsvision_White"
                  opacity=".7"
                  fill="#fff"
                  d="M357.6 130.5L99.4 195v18.4l184.4 46.2L542 195v-18.4z"
                />
              </g>
              <g
                id="Ausbildungsvision"
                className="m-Sandwich-layer m-Sandwich-avLayer"
                data-index={2}
              >
                <path
                  fill="#00493e"
                  d="M357.5 94.1L99.3 158.7v18.4l184.4 46.1L542 158.7v-18.5z"
                />
                <path
                  className="st2"
                  opacity=".1"
                  d="M283.7 204.8v18.4L542 158.7v-18.5z"
                />
                <path
                  className="st3"
                  opacity=".2"
                  d="M99.3 158.7v18.4l184.4 46.1v-18.4z"
                />
                <path
                  id="Ausbildungsvision_White"
                  opacity=".4"
                  fill="#fff"
                  d="M99.3 177.1v-18.4l258.2-64.6L542 140.2v18.5l-258.3 64.5z"
                />
              </g>
              <g
                id="Spielvision"
                className="m-Sandwich-layer m-Sandwich-svLayer"
                data-index={1}
              >
                <path
                  fill="#20ae80"
                  d="M357.7 57.1L99.5 121.6v18.5l184.4 46.1 258.2-64.6v-18.4z"
                />
                <path
                  className="st2"
                  opacity=".1"
                  d="M283.9 167.7v18.5l258.2-64.6v-18.4z"
                />
                <path
                  className="st3"
                  opacity=".2"
                  d="M99.5 121.6v18.5l184.4 46.1v-18.5z"
                />
                <path
                  className="st10"
                  fill="#fff"
                  d="M273.4 122.9l5.3 1.4 15.8-4-5.3-1.3zM299.8 116.4l5.3 1.3 15.8-4-5.3-1.3zM326.1 109.8l5.3 1.3 15.8-4-5.3-1.3zM352.5 103.2l5.3 1.3 15.8-3.9-5.3-1.4zM247.1 129.5l5.3 1.4 15.8-4-5.3-1.3zM220.7 136.1l5.3 1.3 15.8-3.9-5.3-1.3zM194.4 142.7l5.3 1.3 15.8-3.9-5.3-1.3zM431.5 83.4l5.3 1.3 15.8-3.9-5.3-1.3zM405.2 90l5.3 1.3 15.8-3.9-5.3-1.3zM378.8 96.6l5.3 1.3 15.8-3.9-5.3-1.4zM117.6 126.2l5.3 1.3 258.2-64.6-5.3-1.3zM260.6 161.9l5.3 1.3 258.2-64.5-5.3-1.4z"
                />
                <path
                  id="Spielvision_White"
                  opacity=".4"
                  fill="#fff"
                  d="M99.5 140.1v-18.5l258.2-64.5 184.4 46.1v18.4l-258.2 64.6z"
                />
              </g>
            </svg>
          </div>
        </div>
        <div className="m-Sandwich-container m-Sandwich-container--mobile">
          <div className="c-Headline m-Sandwich-headline">
            <DfbHeadline
              headline={props.data.headline}
              headline_level="h2"
              add_class="c-Headline-strokeLine"
            />
          </div>
          <div
            className="dfb-Slider m-Sandwich-slider"
            data-transition="slide"
            data-indicators
            data-drag
            data-controls
            role="region"
            tabIndex={0}
          >
            <div className="dfb-Slider-slider">
              <ul className="dfb-Slider-slides">
                {props.data.sandwich_item.map((item, index) => (
                  <li className="dfb-Slider-slideItem">
                    <figure className="m-Sandwich-figure">
                      {index === 0 && (
                        <img
                          className="m-Sandwich-image"
                          src="https://www.dfb-akademie.de/static/assets/images/static/Sandwich-Trainingsvision.png"
                          alt={item.headline}
                        />
                      )}
                      {index === 1 && (
                        <img
                          className="m-Sandwich-image"
                          src="https://www.dfb-akademie.de/static/assets/images/static/Sandwich-Ausbildungsvision.png"
                          alt={item.headline}
                        />
                      )}
                      {index === 2 && (
                        <img
                          className="m-Sandwich-image"
                          src="https://www.dfb-akademie.de/static/assets/images/static/Sandwich-Spielvision.png"
                          alt={item.headline}
                        />
                      )}
                      {index === 3 && (
                        <img
                          className="m-Sandwich-image"
                          src="https://www.dfb-akademie.de/static/assets/images/static/Sandwich-deutsche-tugenden.png"
                          alt={item.headline}
                        />
                      )}
                      <figcaption className="m-Sandwich-figcaption">
                        <DfbHeadline
                          headline={item.headline}
                          headline_level="h4"
                          add_class="m-Sandwich-sliderHeadline"
                        />
                        {item.text && <DfbRte text={item.text} />}
                        {item.link && (
                          <div className="m-Sandwich-button">
                            <DfbButton
                              tagName="a"
                              link={item.link}
                              text="Mehr erfahren"
                            />
                          </div>
                        )}
                      </figcaption>
                    </figure>
                  </li>
                ))}
              </ul>
            </div>
            <ul className="dfb-Slider-controls">
              <li className="dfb-Slider-controlElement dfb-Slider-controlElement--previous">
                <button
                  className="dfb-Button dfb-Button--icon dfb-Slider-control dfb-Slider-control--previous"
                  type="submit"
                  aria-label="previous"
                >
                  <svg
                    className="dfb-Symbol dfb-Symbol--dfbIconDropdownLeft"
                    aria-hidden="true"
                  >
                    <use href="#dfb-icon-dropdown-left" />
                  </svg>
                </button>
              </li>
              <li className="dfb-Slider-controlElement dfb-Slider-controlElement--next">
                <button
                  className="dfb-Button dfb-Button--icon dfb-Slider-control dfb-Slider-control--next"
                  type="submit"
                  aria-label="next"
                >
                  <svg
                    className="dfb-Symbol dfb-Symbol--dfbIconDropdownRight"
                    aria-hidden="true"
                  >
                    <use href="#dfb-icon-dropdown-right" />
                  </svg>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MSandwich
